<template>
  <div class="ah-card-species-icons">
    <animal-symbol
      v-for="(animal, i) in species"
      class="ah-card-species-icon"
      :key="`species-icon-${i}`"
      :animal="animal"
    />
  </div>
</template>

<script>
  import AnimalSymbol from '../../AnimalSymbol.vue'

  export default {
    name: 'species-icons',
    props: {
      species: {
        type: Array,
      }
    },
    components: {
      AnimalSymbol
    },
  }
</script>

<style scoped>
  .ah-card-species-icons {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    background-color: white;
    border-bottom-left-radius: 5px;
    padding: 10px;
    border: 1px solid #DCDCE5;
    border-top: none;
    border-right: none;
  }
  .ah-card-species-icon {
    max-height: 28px;
    max-width: 28px;
    margin: 0 2px;
  }
</style>
